import { AdminToolbar, SearchField } from "@/components/admin";
import { OrganizationCombobox } from "@/components/shared/OrganizationCombobox";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

export interface UsersToolbarProps {
    search: string;
    onSearchChange: (value: string) => void;
    onSearchClear: () => void;
    organizationId: number | null;
    onOrgIdChange: (id: number | null) => void;
    role: "admin" | "user" | null;
    onRoleChange: (role: "admin" | "user" | null) => void;
    invitationStatus: "accepted" | "pending" | null;
    onInvitationStatusChange: (status: "accepted" | "pending" | null) => void;
}

export function UsersToolbar({
    search,
    onSearchChange,
    onSearchClear,
    organizationId,
    onOrgIdChange,
    role,
    onRoleChange,
    invitationStatus,
    onInvitationStatusChange,
}: UsersToolbarProps) {
    return (
        <div className="mb-4">
            <AdminToolbar>
                <SearchField
                    value={search}
                    onChange={onSearchChange}
                    onClear={onSearchClear}
                    placeholder="Search users..."
                />

                <OrganizationCombobox
                    value={organizationId}
                    onChange={onOrgIdChange}
                />

                <Select
                    value={role ?? "all"}
                    onValueChange={(val) =>
                        onRoleChange(
                            val === "all" ? null : (val as "admin" | "user")
                        )
                    }
                >
                    <SelectTrigger className="h-8 w-36 text-sm">
                        <SelectValue>
                            {role === null
                                ? "All Roles"
                                : role === "admin"
                                  ? "Admin"
                                  : "User"}
                        </SelectValue>
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="all">All Roles</SelectItem>
                        <SelectItem value="admin">Admin</SelectItem>
                        <SelectItem value="user">User</SelectItem>
                    </SelectContent>
                </Select>

                <Select
                    value={invitationStatus ?? "all"}
                    onValueChange={(val) =>
                        onInvitationStatusChange(
                            val === "all"
                                ? null
                                : (val as "accepted" | "pending")
                        )
                    }
                >
                    <SelectTrigger className="h-8 w-44 text-sm">
                        <SelectValue>
                            {invitationStatus === null
                                ? "All Invitation Statuses"
                                : invitationStatus === "accepted"
                                  ? "Accepted"
                                  : "Pending"}
                        </SelectValue>
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="all">
                            All Invitation Statuses
                        </SelectItem>
                        <SelectItem value="accepted">Accepted</SelectItem>
                        <SelectItem value="pending">Pending</SelectItem>
                    </SelectContent>
                </Select>
            </AdminToolbar>
        </div>
    );
}
